import React, { useState, useEffect } from "react";
import Classes from "./Footer.module.css";
import { scrollToElement } from "../../../utils/scrollToElement";
import { useLocation, useNavigate } from "react-router-dom";
import StoreSelectionPopup from "./StoreSelectionPopup";
import { AndroidIcon, AppleIcon, FacebookIcon, InstaIcon, LinkedInIcon, TiktokIcon } from "../../../utils/Icons";

const IOS_APP_LINK =
  "https://apps.apple.com/us/app/fuelclubs/id6753362541";
const ANDROID_APP_LINK =
  "https://play.google.com/store/apps/details?id=com.devzona.fuelclubs";

export default function Footer() {
  const navigateTo = useNavigate();
  const location = useLocation();
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1280
  );
  const [showStorePopup, setShowStorePopup] = useState(false);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = width < 768;

  const handleScrollOrNavigate = (id, pathTo, offset = 0) => {
    if (location.pathname !== pathTo) {
      navigateTo(pathTo, { state: { scrollTo: { id, offset } } });
    } else {
      scrollToElement(id, offset);
    }
  };

  const handleGetStarted = () => {
    // if (isMobile) {
    //   // Mobile → open store selection popup
    //   setShowStorePopup(true);
    // } else {
    //   // Desktop → go to signup
    //   ;
    // }
    navigateTo("/signup")
  };

  const handleStoreSelect = (platform) => {
    const url = platform === "ios" ? IOS_APP_LINK : ANDROID_APP_LINK;
    window.open(url, "_blank");
  };

  return (
    <>
      <footer className={Classes.footer}>
        <div className={Classes.topArea}>
          <div className={Classes.leftBlock}>
            {/* <a href="/" style={{ height: '2.2rem', width: 'fit-content' }} >
                        <img src="/assets/images/logoWhite.png" style={{ height: '100%' }} draggable={false} />
                    </a> */}
            <div className={Classes.ctaCard}>
              <p>
                Convenient, reliable fuel delivery—so you never have to stop
                for gas again.
              </p>
              <button onClick={handleGetStarted}>
                <h5>Get Started for Free</h5>
              </button>
            </div>
          </div>

          {/* Right: Footer navigation columns */}
          <div className={Classes.navColumns}>
            <div>
              <h4>Product</h4>
              <ul>
                <li>
                  <h5
                    onClick={() => { navigateTo('/how-it-works') }}
                  >
                    How it Works
                  </h5>
                </li>
                <li>
                  <h5
                    onClick={() => handleScrollOrNavigate('membership', '/', 25)}
                  >
                    Memberships
                  </h5>
                </li>
                <li>
                  <h5
                    onClick={() => { navigateTo('/testimonials') }}
                  >
                    Testimonials
                  </h5>
                </li>
              </ul>
            </div>
            <div>
              <h4>Company</h4>
              <ul>
                <li>
                  <h5>Blog</h5>
                </li>
                <li>
                  <h5
                    onClick={() => handleScrollOrNavigate('faq', '/how-it-works', 0)}
                  >
                    FAQ
                  </h5>
                </li>
                <li
                  onClick={() => {
                    navigateTo("/contact-us");
                  }}
                >
                  <h5>Contact</h5>
                </li>
              </ul>
            </div>
            <div>
              <h4>Legal</h4>
              <ul>
                <li>
                  <a href="/data-security" target="_blank" rel="noopener noreferrer">
                    <h5>Data Security</h5>
                  </a>
                </li>
                <li>
                  <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">
                    <h5>Terms of Use</h5>
                  </a>
                </li>
                <li>
                  <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                    <h5>Privacy Policy</h5>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider line */}
        <div className={Classes.divider}></div>

        {/* Bottom bar: copyright + social */}
        <div className={Classes.bottomBar}>
          <span>
            <h5>© 2025 FuelClubs. All rights reserved.</h5>
          </span>
          <div className={Classes.linksCon} >
            <a href="https://www.facebook.com/fuel.clubs" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
              <FacebookIcon />
            </a>
            <a href="https://www.linkedin.com/in/fuelclubs-%E2%9B%BD%EF%B8%8F-729881379/" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
              <LinkedInIcon />
            </a>
            <a href="https://www.tiktok.com/@fuelclubs" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
              <TiktokIcon />
            </a>
            <a href="https://www.instagram.com/fuelclubs/" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
              <InstaIcon />
            </a>
            <a href="https://apps.apple.com/app/id6753362541" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
              <AppleIcon />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.devzona.fuelclubs" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
              <AndroidIcon />
            </a>
          </div>
        </div>
        <div className={Classes.developedBy}>
          <h5>
            Developed by{" "}
            <a href="https://evolvion.io" target="_blank" rel="noopener noreferrer">
              Evolvion
            </a>
          </h5>
        </div>
      </footer>

      {/* Reusable Store Selection Popup */}
      <StoreSelectionPopup
        open={showStorePopup}
        onClose={() => setShowStorePopup(false)}
        onSelect={handleStoreSelect}
      />
    </>
  );
}
